import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "That time monkey patching took 2 days off my life",
  "description": "",
  "published": "2019-10-14T00:00:00.000Z",
  "redirect_from": ["/blog/that-time-monkey-patching-took-2-days-off-my-life/swizec/9216"],
  "categories": "Back End, Technical",
  "hero": "./img/gJIXI8O.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "890px",
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/83bc09a5420f84c6575252c554666185/72e01/gJIXI8O.jpg",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "66.81614349775785%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'267\\'%20viewBox=\\'0%200%20400%20267\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M1%200c0%202%205%206%208%207s1%203-3%202c-5%200-6%203-2%204%202%201%203%204%201%204l-1%202-3%202c-2%200-1%204%201%204l7%205c-1%201-1%201%201%201l4%202h2l2-1%201-2c-1-2-1-2%206-2l9%201%202%201-2%201c-2%200-2%200%200%201%203%202%204%205%201%205l-4%202c-2%202-8%200-7-3l-5%201c-7%203-7%203-3%205l4%205%202%204v6l-2%202-2%203c-1%201-1%201%204%201%203-1%205%200%206%201l5%201c2%200%203%200%203%202l2%202%201%201-2%202c0%202-1%203-3%203-3%200-3%202%201%204l4%205c1%202%202%205%204%206l2%202c0%204%202%204%204%203s3-2%204-1l1-1-3-3-3-3-2-3%202-1%204%202%202%201%204%203c2%203%203%207%200%207v2c2%201%206%200%204-2l1-2%202-4%201-7c2-5%201-6-2-3-2%202-2%203-1%204s1%201-3%201c-6-1-8-3-6-5%202-1%202-1%201-4s0-5%203-7c1-1%201-3-1-4v-2l1-1-1-2-1-2c0-2%200-2-3-1h-3l1-3c2-3%201-6-3-6-3%200-6-3-4-5%201-2%209-1%2015%201s6%202%203-1c-1-2-2-3-3-2l-1-1v-1c-2-1%200-5%204-6s10-1%2010%201c0%203%200%204%203%204%201%200%202%200%201%201l3%204%201-2%201%202c0%203%201%203%203%203l4-1c0-3%202-4%206-3%203%200%203%200%203-2v-4c1-1%201-2%205%2014l3%2010-2-12c-4-14-5-13%208-12h12l-2%203c-1%203-1%203%201%206%202%201%203%203%202%203l1%201%206-6c3-4%209-7%2012-6h12l4%203c3%202%203%202%203%200l1-3c-1-1%203-2%203-1v4c-1%205-1%206%202%204h8c2-1%203-1%205%201l8%201h5l1%202c3%201-3%207-7%207-4%201-5%200-3-1%204-2%202-4-2-3-4%200-10-1-11-4h-2l2%204%203%206c0%202%200%202%202%202%201-1%201%200%202%202a579%20579%200%200010%2024c-3%203-2%204%201%204s3%205-1%206l-2%202-2%204c-1%201-1%201-3-1s-6-2-6%200l-1%202-2%204c0%203%200%203%203%203s4-1%204-3l1-2%201%202%202%206c0%202%200%202-3%202-5-2-6-2-5%201l-1%203v2c2%202%201%204-1%206s-3%202-3%201c0-2-2-1-2%201l-1%201v2c1%201%2011%202%2012%200%201-1%200-3-2-3s-1-4%201-5l3%201c3%201%208%201%209-2%200-2%202-3%203%200%202%201%202%201%204-1l2-5%201-2%201%203%202%203c1%200%204-7%203-8%200-2-5-3-5-1l-5%201-5-1%203-1c6%200%207-1%207-7l-1-5-1-3c0-2%200-2-2-2-2%201-6-1-4-2%201-1%207%201%207%203%200%203%202-1%202-4%200-4-1-5-2-6-4-1-5-9-3-15l2-5%202-3c1-2%201-2%201%201%200%204%203%204%205%201%201-3%201-5-2-5s-6-4-5-5v-8c0-3%200-3-2-3-4%200-4%200-1-3l1-3%202-1c2%200%203%201%203%202%200%202%201%203%203%202v-2h1v-1c0-2%200-2%203%200l1%202-1%204%203-1c3-1%203-1%203%202l-1%204c-1%202%200%202%202%201l2-2c0-4%205-1%208%206l4%203c3%200%2032%2012%2035%2015%202%201%203%2013%201%2015v7c-1%201-2%202-1%203l-2%203-1%209c0%2016-11%2035-19%2034-3-1-7%202-7%205l-4%208c-4%209-4%2010%203%2016l4%205-2%207c-2%208-4%2010-8%208-1-1-2%200-4%201-1%202-3%202-5%202-2-1-3%200-4%201-2%202-3%202-5%202-1-1-3%200-5%201-2%202-4%202-6%202h-4c0%201-2%202-5%202-4%200-6%200-8%202-3%204-5%204-8-3l-5-8c-2-2-2-2-1%201l2%205c3%203%203%208%201%2010-3%203-1%204%206%206l10%204c2%202%203%203%205%202%203-1%208%200%208%202l3%201c2-1%2010%201%2010%202l4%201%206%201c0%202%202%202%203%202%202-1%202-1%202%202-2%206-4%2026-4%2031s1%207%202%203h1c0%202%202%202%2034%202a163%20163%200%200036-1l7%201h7v-3c-2-8-2-9%200-11l4-2c2%200%203-3%201-4s-6%200-6%202l-1%201-1-2-2-6c-3-5-2-5%203-5l5-1%205-1%205-2%204-1c2%200%205%202%203%203v5l3-2%202-1h1l1-2h1l5%201%202-1-1-3v-3l3%202%202%204v1l1%201-1%201-3%201%201%201c1-1%202%200%202%201l-1%201-1%202c0%202-1%203-5%204l-2%201a3013%203013%200%200010%201l-2%204v1c1%200%201%201-1%202-1%202-1%202%201%202h3l-2%201c-3%200-4%203-2%205%203%203%2049%203%2049%200l-2-2-2-1-2-1c-3%200-4-2-2-5h1c0%202%201%202%203%201l3%201c1%201%201-1%201-5l-1-6-3-1-3-1h3c3%200%203%200%201-1l-3-2%202-1%203%201%201-76V90h-3l-5-1c-3-3-4-2-4%200s-6%204-7%202c-2-1%200-3%204-3l3-2c0-5%202-5%205%200%201%203%204%205%202%201-3-7-2-14%202-12%201%201%202%202%201%203l1%202%201-8-1-5c-1%202-2%201-1-2l1-1%201-2-1-2v-1c2%200%201-9%200-9l-2-2-1-2-1%201c0%203-3%205-3%203V40l7-3c2%202%202-24-1-26V8l2-5V0h-47a439%20439%200%2000-50%201l-24-1-26%201h-1c0-1-63-2-66%200-2%200-3%203-1%203v5c-2%200-2%201-1%202h4c-1%202%200%202%202%201%201%200%202-1%201-2%200-2%200-2%201-1%201%200%202%201%201%202v2l-1%201c-2-2-1%201%202%202%202%202%202%202%202%200h2l1%203%201%201h1l3%202c3%202%202%202-2%201h-9l-5-2-8-3-9-4-6-5V6l-1%201c-1%203-1%203-3%201l-3-1-3-3c0-3-1-4-3-4s-2%200-1%201v3c-1%202-7%200-10-3a259%20259%200%2000-54%200c-2%200-6%201-12%206l-9%205-5%205-7%204a4785%204785%200%2000-11%203c-1-2-2-2%203-4%202-1%204-2%206-1l5-1v-2l-1-2c0-3%200-3%204-3s4%200%206-3l5-4c13-4%2010-4-31-4H1m227%2011h-3c-2-2-3-1-2%203%200%204%200%204-2%204-4-2-2%201%205%206%205%204%206%204%207%202%202-2%202-3-2-3s-4-2-1-5l2-4%202-2%203-1h-3l-2-1c0-1-1-1-4%201m-76%202c-2%201-2%202-1%202h-1c-2%200-3%200-2%201%201%200-3%203-6%203l-4%202c-1%201-3%202-4%201l-4%201c-2%201-3%200-5-1-3-3-5-2-5%201l2%202%202%202-2%201-2%201-3%201-3%201c2%202%2020%201%2020-1h2l1-2c-1-2%200-3%2010-5l5-3%208-1c5-1%2010-3%205-3l-6-2c-5-2-5-2-7-1m205%2035l-1%204-1%203-1%201-2%202c0%201-1%202-3%202s-6%203-6%205l16-2h1l1-2-2-4c-2%200-2%200-1-4%202-3%202-6%201-6l-2%201M94%2051c-2%201-2%201%200%203v2l-1%202-1%201c-2%201-3%207-1%208%201%200%202%203%200%203l-1%202%201%201%201-1%202-2c2%200%202%201%202%203v2c2%200%202-5%201-7l-1-2-2-3-1-3c1-1%201-1%202%201%202%201%202%201%202-1l-1-3v-1l1-2v-4l-3%201m296%209l-1%201c0-2-2-1-5%202-2%203-3%204-2%205s1%201-1%201c-2-1-2-1%200%204%203%206%205%207%209%204%201-1%201-1%201%201h1v-5l2-4h1c2%202%202%201%200-2l-1-2-1%202v-8c0-2-2-1-3%201m-241%207c0%203%201%206%203%206l2%201v3c0%202%203%203%204%200l4-1%204%201-2%202c-3%203%200%203%203%201%204-3%204-3%200-7-3-4-4-4-8-4l-6%201c0%201-2%200-3-2l-1-1m52%204c-2%202-2%205%201%204%203%200%204%203%204%208v6l1%202%202-2c3-2%204-2%202%201l-2%203c0%202%202%201%203-1s4-3%206-2c1%201%201%200%202-1%201-4%201-4-2-4-2%201-6-3-5-6l-1-1-2-6c0-2-6-3-9-1M74%2088c-1%205-1%205-2%203s-2-1-3%204c0%205%200%205%202%204s2-1%202%201l1%201%201-3c0-3%203%200%203%204l3%2012c2%202%202%209%200%2014%200%202%200%204%202%205%202%202%202%203%201%203-1%201%200%201%202%201%201%200%204%201%205%203%206%206%209%208%2018%209%208%202%2010%201%2014-4l4-4%204-4c0-3%201-3%203-3l2-2-2-1h-2l2-1v-1h-2c-2%203-6-1-4-6v-4l-2%204c0%206-1%207-3%206l-1-1c1-3-2-3-3-1v4c2%200%202%201%201%202-1%202-2%202-4%200-1-2-4-4-7-5-4-2-6-4-7-6l-3-2c-1%200-2-1-2-3-1-2-1-2-2-1-2%202-5%200-7-5a322%20322%200%2000-1-7c2%200%203-5%201-7h-9l-2-1v-3c3-4%202-7%200-7l-3%202m38%207l1%2012c1%205-2%2012-6%2014l-2%201c0%202%205%203%206%201l3-1c3-1%204-13%202-20-2-5-3-9-1-7v-5c-2-5-3-3-3%205m223-1c1%203%200%205-1%203h-3l-3%201h-6v2l3%201%202%201v2h-2c-2-1-3-1-2%201l-1%201-1%202c0%202%200%203-3%204l-5%204-2%204-2%204-2%204c-1%202-2%203-1%205%200%203%200%203-2%203-1%200-2%201-3%2013-3%2021-3%2022%200%2021%203%200%204-1%204-2-1-1%201-2%204-1%203%200%207-1%207-3%201-2%200-3-2%200l-3%201%201-2v-2c-1-1-1-1%201-1%203%200%207-2%207-4v-1c1%200%202%201%201%204-1%202-1%202%201%203%206%201%2025-5%2020-7-2%200%200-3%202-2l2%201c0%202%200%202%205%201l4-3%202-3-2-1-4-1c-1-2%201-2%203-1s2%201%202-1h-1v-8l1-5h2l1%201%201%202h-1l-1%203c-1%202%201%202%207%200%203-1%204-1%204%202l-1%202h-1v1l1%201v1l1%201-3%201c-1%200-2%200-1%202l-1%201c-2%200-2%201-2%202%201%201%201%201-1%201-3-1-3%201%200%202%202%201%203%200%206-2%203-3%205-4%2010-4l2-1-1-1c-5%201-9-3-6-7v-2l-2-4%202%201%203%202c2-1%201-3%200-2h-2c0-1%201-2%203-2l10-12%203-4%203-6c-1-3-1-3%201-3l3-1c0-2%200-2-3-1-3%202-4%201-4-2%200-2-1-3-3-1h-1l-2-1h-2l2%201c1%201%202%201%201%202%200%202-1%202-3%201-1-1-1-1-1%201%200%203-2%205-5%204v1l1%202h-2c0-1-1-2-2-1l-3-1h-2l2%202v1h-2l-2%201v2h4v3l-2%202-4-1h-2c0-3%200-4-2-3v-2c2-2%201-5-1-4l-2%201%201%201v2c-1%201-2%202-3%200v-6c0-4%200-4%202-4%201%200%202%200%201%201l-1%202%202-1%201-4c0-1%200-2%202-2l2-1-1-1h-4c-1-1-2%200-3%202l-1%202c-1-1-4%200-5%202-1%201-2%203-4%203l1-2%201-2h-2l-1%201h-1c-1%201-2%203-1%204%200%202-1%203-2%203l-1%202c-1%204%204%2010%207%209l1%201c-1%201-5%202-5%200h-3c-1%201-1%201-1-1%201-2%201-2-1-2l-2%203-1%203-1-3c0-3-1-3-3%201l-3%202%201-2%201-3%201-3%202-4c0-2%200-2-2%200-2%201-2%201-3-1-2-2%200-5%203-5l6-3c3-3%203-4%203-2s0%202%202%201v-3l-2-3h4c1-2%200-4-1-3-2%202-3%201-2-2v-3l-1%202c-2%202-2%202-2%200l-1-3-1%202m-65%2038l-1%202-1%203h-3v3l-2%203c-2%202-5%208-5%2011%200%202%200%202%202%201l2%201c-1%201%200%201%201%201%202%200%203-2%201-3h-2l2-4c2-2%203-3%204-1%202%201%202%201%202-1l-1-2c-2%200-2-3%200-7s2-9%201-7M154%20259l-1%203c-2%201-3%200-1-2v-1c-2%200-4%203-2%204s-1%202-4%201c-2%200-2%200-1%201%200%202%202%202%2011%202%2010%200%2014-1%209-2l-4-4c-1-3-3-4-3-1-1%201-1%201-2-1%200-2-2-3-2%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/83bc09a5420f84c6575252c554666185/ca0a1/gJIXI8O.webp 223w", "/static/83bc09a5420f84c6575252c554666185/75680/gJIXI8O.webp 445w", "/static/83bc09a5420f84c6575252c554666185/8d1ba/gJIXI8O.webp 890w", "/static/83bc09a5420f84c6575252c554666185/a9a89/gJIXI8O.webp 1024w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/83bc09a5420f84c6575252c554666185/853b2/gJIXI8O.jpg 223w", "/static/83bc09a5420f84c6575252c554666185/0a4fe/gJIXI8O.jpg 445w", "/static/83bc09a5420f84c6575252c554666185/7f80b/gJIXI8O.jpg 890w", "/static/83bc09a5420f84c6575252c554666185/72e01/gJIXI8O.jpg 1024w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/jpeg"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/83bc09a5420f84c6575252c554666185/7f80b/gJIXI8O.jpg",
              "alt": "gJIXI8O",
              "title": "gJIXI8O",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`Monkey patching is a programming technique popular in the Ruby world and nipped-in-the-bud by the JavaScript Community. Good.`}</p>
    <p>{`Remember the `}<a parentName="p" {...{
        "href": "https://developers.google.com/web/updates/2018/03/smooshgate"
      }}>{`smoosh controversy`}</a>{`? JavaScript couldn't adopt `}<inlineCode parentName="p">{`Array.flatten`}</inlineCode>{` because `}<a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/MooTools"
      }}>{`MooTools`}</a>{` used it in the 2010's and making a new one might break the web. That was due to monkey patching.`}</p>
    <p>{`So what's monkey patching anyway?`}</p>
    <p>{`I'm glad you asked`}</p>
    <h2 {...{
      "id": "monkey-patching"
    }}>{`Monkey Patching`}</h2>
    <blockquote>
      <p parentName="blockquote">{`the term `}<a parentName="p" {...{
          "href": "https://en.wikipedia.org/wiki/Monkey_patch"
        }}>{`monkey patch`}</a>{` only refers to dynamic modifications of a class or module at runtime, motivated by the intent to patch existing third-party code as a workaround to a bug or feature which does not act as desired`}</p>
    </blockquote>
    <p>{`You can think of monkey patching as a magic trick. Run a function and it changes how other functions behave without changing the source code.`}</p>
    <p>{`Let's take `}<inlineCode parentName="p">{`.flat`}</inlineCode>{` for example. It recursively flattens an array.`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=%3E%20%5B1%2C%20%5B2%2C%203%2C%20%5B4%2C%205%5D%5D%5D.flat()%0A%2F%2F%20(4)%C2%A0%5B1%2C%202%2C%203%2C%20Array(2)%5D%0A%0A%3E%20%5B1%2C%20%5B2%2C%203%2C%20%5B4%2C%205%5D%5D%5D.flat(2)%0A%2F%2F%20(5)%C2%A0%5B1%2C%202%2C%203%2C%204%2C%205%5D"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "334px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "77.57847533632287%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'310\\'%20viewBox=\\'0%200%20400%20310\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M41%2060c-2%202-2%2013-2%2096l1%2096c2%203%206%203%20161%203%20154%200%20158%200%20160-3a3088%203088%200%2000-1-192l-1-2H42l-1%202m42%2018c-4%205-1%2012%205%2012s9-8%205-12c-3-3-7-3-10%200m26-1c-5%202-5%2010%200%2012%206%203%2011-3%209-8l-6-5-3%201\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/9870d09dfd2b6a4b5ac450b69518cdf2/ca0a1/techletter.app-screenshot-1571068942459.webp 223w", "/static/9870d09dfd2b6a4b5ac450b69518cdf2/7390e/techletter.app-screenshot-1571068942459.webp 334w"],
                "sizes": "(max-width: 334px) 100vw, 334px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/9870d09dfd2b6a4b5ac450b69518cdf2/e92b6/techletter.app-screenshot-1571068942459.png 223w", "/static/9870d09dfd2b6a4b5ac450b69518cdf2/86d36/techletter.app-screenshot-1571068942459.png 334w"],
                "sizes": "(max-width: 334px) 100vw, 334px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/9870d09dfd2b6a4b5ac450b69518cdf2/86d36/techletter.app-screenshot-1571068942459.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`Now let's say you disagree with the levels of recursion argument. You want `}<inlineCode parentName="p">{`.flat`}</inlineCode>{` to always completely flatten an array.`}</p>
    <p>{`You can overwrite JavaScript's native `}<inlineCode parentName="p">{`.flat`}</inlineCode>{` implementation. Run this somewhere, anywhere, in your codebase.`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=Array.prototype.flat%20%3D%20function()%20%7B%0A%20%20return%20this.reduce((arr%2C%20cur)%20%3D%3E%20%7B%0A%20%20%20%20if%20(Array.isArray(cur))%20%7B%0A%20%20%20%20%20%20return%20%5B...arr%2C%20...cur.flat()%5D%3B%0A%20%20%20%20%7D%20else%20%7B%0A%20%20%20%20%20%20return%20%5B...arr%2C%20cur%5D%3B%0A%20%20%20%20%7D%0A%20%20%7D%2C%20%5B%5D)%3B%0A%7D%3B"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "398px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "82.95964125560539%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'333\\'%20viewBox=\\'0%200%20400%20333\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M34%2050l-1%20118c0%20114%200%20116%202%20117h331c2-1%202-3%202-117l-1-118c-2-2-331-2-333%200m36%2016c-4%203-1%2010%204%2010l4-2%202-4c0-5-7-8-10-4m20%200c-3%203-3%205%200%208%204%203%204%203%208-1%201-1%202-3%201-4-1-5-6-6-9-3\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/db03eb6b3f7d395fce7df3bcc61ed2f6/ca0a1/techletter.app-screenshot-1571068942189.webp 223w", "/static/db03eb6b3f7d395fce7df3bcc61ed2f6/579c2/techletter.app-screenshot-1571068942189.webp 398w"],
                "sizes": "(max-width: 398px) 100vw, 398px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/db03eb6b3f7d395fce7df3bcc61ed2f6/e92b6/techletter.app-screenshot-1571068942189.png 223w", "/static/db03eb6b3f7d395fce7df3bcc61ed2f6/692d4/techletter.app-screenshot-1571068942189.png 398w"],
                "sizes": "(max-width: 398px) 100vw, 398px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/db03eb6b3f7d395fce7df3bcc61ed2f6/692d4/techletter.app-screenshot-1571068942189.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`Overwrite `}<inlineCode parentName="p">{`Array.prototype.flat`}</inlineCode>{` and replace it with a function of your own.`}</p>
    <p><inlineCode parentName="p">{`.reduce`}</inlineCode>{` the array and use `}<inlineCode parentName="p">{`...`}</inlineCode>{` to combine values. When the current value is an array, go into recursion, otherwise use the value.`}</p>
    <p>{`Every array in your codebase now has this function. 🧙‍♂️`}</p>
    <p>{`Here's a CodeSandbox to prove it works`}</p>
    <p><a parentName="p" {...{
        "href": "https://codesandbox.io/s/js-monkey-patch-jpwru"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "640px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "54.26008968609865%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'217\\'%20viewBox=\\'0%200%20400%20217\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M0%20109v108h401V0H0v109m229%204v98h171V15H229v98M3%20105v2h51v-5H3v3m-1%2078c0%209%200%209%202%209h4c3-2%205-1%205%201s1%202%205%202h5v-9l-1-9-2-1c0-2-2-2-9-2H2v9\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/918060df402697ad63ed55caebb105de/ca0a1/techletter.app-screenshot-1571068952841.webp 223w", "/static/918060df402697ad63ed55caebb105de/75680/techletter.app-screenshot-1571068952841.webp 445w", "/static/918060df402697ad63ed55caebb105de/0ba47/techletter.app-screenshot-1571068952841.webp 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/918060df402697ad63ed55caebb105de/e92b6/techletter.app-screenshot-1571068952841.png 223w", "/static/918060df402697ad63ed55caebb105de/e66bf/techletter.app-screenshot-1571068952841.png 445w", "/static/918060df402697ad63ed55caebb105de/6af66/techletter.app-screenshot-1571068952841.png 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/918060df402697ad63ed55caebb105de/6af66/techletter.app-screenshot-1571068952841.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <h2 {...{
      "id": "when-monkey-patching-goes-rogue"
    }}>{`When monkey patching goes rogue`}</h2>
    <p>{`Monkey patching on its own ain't bad at all. It's a great tool when used responsibly. You can make non-standard methods easy to use, add to your language's standard library, and even fix bugs.`}</p>
    <p><a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/Polyfill_(programming)"
      }}>{`Polyfills`}</a>{` are an example of successful monkey patching in the JavaScript world. Adding features to browsers that otherwise don't have them.`}</p>
    <p>{`But we can take that `}<inlineCode parentName="p">{`.flat`}</inlineCode>{` example from before and make it sinister.`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=console.log(%5B1%2C%20%5B2%2C%203%5D%5D.flat())%3B%0A%2F%2F%20%5B1%2C%202%2C%203%5D%0A%0Aconsole.log(%5B1%2C%20%5B2%2C%203%2C%20%5B4%2C%205%5D%5D%5D.flat())%3B%0A%2F%2F%20%5B1%2C%202%2C%203%2C%204%2C%205%5D%0A%0Aconsole.log(%5B1%2C%20%5B2%2C%203%2C%20%5B4%2C%205%5D%2C%20%5B6%2C%207%2C%20%5B8%2C%209%2C%20%5B10%2C%2011%5D%5D%5D%5D%5D.flat())%3B%0A%2F%2F%20%5B1%2C%202%2C%203%2C%204%2C%205%2C%20%22%F0%9F%A7%99%E2%80%8D%E2%99%82%EF%B8%8F%22%2C%206%2C%207%2C%208%2C%209%2C%20%22%F0%9F%A7%99%E2%80%8D%E2%99%82%EF%B8%8F%22%2C%2010%2C%2011%5D"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "630px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "49.77578475336323%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'199\\'%20viewBox=\\'0%200%20400%20199\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M21%2033a1991%201991%200%20001%20135c2%202%20354%202%20356%200%202-1%202-7%202-68l-1-67c-1-3-357-3-358%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/9baf07890ef6cddb9723893b6605c243/ca0a1/techletter.app-screenshot-1571068942441.webp 223w", "/static/9baf07890ef6cddb9723893b6605c243/75680/techletter.app-screenshot-1571068942441.webp 445w", "/static/9baf07890ef6cddb9723893b6605c243/8aab1/techletter.app-screenshot-1571068942441.webp 630w"],
                "sizes": "(max-width: 630px) 100vw, 630px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/9baf07890ef6cddb9723893b6605c243/e92b6/techletter.app-screenshot-1571068942441.png 223w", "/static/9baf07890ef6cddb9723893b6605c243/e66bf/techletter.app-screenshot-1571068942441.png 445w", "/static/9baf07890ef6cddb9723893b6605c243/f058b/techletter.app-screenshot-1571068942441.png 630w"],
                "sizes": "(max-width: 630px) 100vw, 630px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/9baf07890ef6cddb9723893b6605c243/f058b/techletter.app-screenshot-1571068942441.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`Whoa where'd that wizard come from?`}</p>
    <p>{`Some unscrupulous programmer monkey patched our `}<inlineCode parentName="p">{`.flat`}</inlineCode>{` method to add a wizard after every 5th element. How dare they play such a trick on us!`}</p>
    <p><a parentName="p" {...{
        "href": "https://codesandbox.io/s/js-monkey-patch-bad-7r2zd"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "640px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "54.26008968609865%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'217\\'%20viewBox=\\'0%200%20400%20217\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M0%20109v108h401V0H0v109m229%204v98h171V15H229v98M3%20112v2h51v-5H3v3\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/bc29b198f32c44e869e693bc47c49002/ca0a1/techletter.app-screenshot-1571068952960.webp 223w", "/static/bc29b198f32c44e869e693bc47c49002/75680/techletter.app-screenshot-1571068952960.webp 445w", "/static/bc29b198f32c44e869e693bc47c49002/0ba47/techletter.app-screenshot-1571068952960.webp 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/bc29b198f32c44e869e693bc47c49002/e92b6/techletter.app-screenshot-1571068952960.png 223w", "/static/bc29b198f32c44e869e693bc47c49002/e66bf/techletter.app-screenshot-1571068952960.png 445w", "/static/bc29b198f32c44e869e693bc47c49002/6af66/techletter.app-screenshot-1571068952960.png 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/bc29b198f32c44e869e693bc47c49002/6af66/techletter.app-screenshot-1571068952960.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <h2 {...{
      "id": "and-then-monkey-patching-took-2-days-off-my-life"
    }}>{`And then monkey patching took 2 days off my life`}</h2>
    <p>{`That's what happened to me one fateful day when a feature finally shipped to production after a million rounds of testing. We got it to work, product was happy, QA was happy, PR was happy. Ship it.`}</p>
    <p>{`boom 💥`}</p>
    <p>{`I mean the feature worked but ...`}</p>
    <p><a parentName="p" {...{
        "href": "https://twitter.com/Swizec/status/1181279294535790600"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "640px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "76.68161434977578%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'308\\'%20viewBox=\\'0%200%20400%20308\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M31%2021c-13%208-7%2028%208%2028%205%200%2011-3%2011-5l-2-1c-4%200-4-1-3-4l5-2c8%201%203-14-6-17-4-2-9-1-13%201m309%20111l-3%2022-1%206-2-8c-3-10-4-9-5%204-1%208-2%2011-3%2011-1-1-4%209-4%2014l-1%203-1%202c0%204-3%207-6%207h-4l-3-2-4-5c-2-3-3-4-4-3s-1%200-2-3c0-4%200-4-2-3-1%202-1%202-3-4-1-4-3-7-3-4%200%202-2%201-2-2-1-6-4-14-5-14l-2%2012c-1%2012-3%2018-5%2019-2%200-4%201-4%203%201%2010-12%208-16-2l-2-2-2%201%201-2v-3l-2-4h-1v-1c0-4-4-16-6-16h-1l-2-6-2-5-1%205-2%2024c-1%2019-2%2023-4%2020-1-1-2%200-4%201-6%205-21%205-26-1l-3-1h-1v-2h-1l-2%201c-2%200-2%200%200%201h-6v-1c1-1%201-1-1-2h-3c-1%201-2%201-3-1l-2-1v3c-1%200-2%200-1-1l-1-1-1%202v1l-2%202c-2%203-3%203-5%203l-8%201c-6%201-9-1-9-5h-1v-1l-1-1c-2%202-4%200-3-2v-1h-3l-2%201%201%201%202%201v1l-7-2-7-1c-1-1-8%202-7%203l3-1h4l3%201h4c3%201%202%201-3%201l-12%201-1%201-3%202c-2%202-13%201-14-1l-5-4c-5-4-5-5-1-5%202%201%203-1%200-2l-4-2c-1-2-2-2-2-1l2%203%201%202-2-1c-2-1-2-1-2%201l-1%202v3l-2%201c-2%200-2%200-1-1l1-1-3-3c-1-2-1-2-2%201l-1%203-1%201c1%201-1%201-3%201-4-1-5%200-6%201-3%204-15%205-18%202l-3-1-2-1h2l1-1-2-1-3-5-3-7c-1-3-1-3-3-1l-1%203c0%202%200%202%201%200s1-2%203-1v3c-2-1-2-1-2%201l-2%201-1%201-1%205c0%204%201%205%203%202%201-3%203-2%206%201l2%203H39l-12%201%20173%201h173v-11c0-8%200-10-1-9l-5%201c0-2%202-3%203-2%202%200%203-4%203-10v-3l-1%202-3%203c-2%200-1-2%201-4l2-6v-1l-2%203-7%2016c-1%205-3%206-4%202v-2l-1%202-1%203-1-3-1-7-2-7-2-12a183%20183%200%2000-4-20c0-3%200-3-1-2-2%203-3%202-3%200l-1-2-1-4%201-4%201%202c0%203%202%203%202%200l1%202c1%204%201%204%201-2l-1-9-1-2v2c0%203-2%204-2%201l-1-3-2%2015M73%20248c-5%202-4%2011%201%2013l4%201%204-2c7-7%200-16-9-12m17%201c-7%207%204%2017%2011%2011%203-4%203-8%200-11s-8-3-11%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/13d6bf3267aafb7b738283543b40dc4e/ca0a1/techletter.app-screenshot-1571068941374.webp 223w", "/static/13d6bf3267aafb7b738283543b40dc4e/75680/techletter.app-screenshot-1571068941374.webp 445w", "/static/13d6bf3267aafb7b738283543b40dc4e/0ba47/techletter.app-screenshot-1571068941374.webp 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/13d6bf3267aafb7b738283543b40dc4e/e92b6/techletter.app-screenshot-1571068941374.png 223w", "/static/13d6bf3267aafb7b738283543b40dc4e/e66bf/techletter.app-screenshot-1571068941374.png 445w", "/static/13d6bf3267aafb7b738283543b40dc4e/6af66/techletter.app-screenshot-1571068941374.png 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/13d6bf3267aafb7b738283543b40dc4e/6af66/techletter.app-screenshot-1571068941374.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`Trouble started on Friday as soon as we deployed. Yes we deployed on Friday.`}</p>
    <p>{`Our `}<a parentName="p" {...{
        "href": "https://sentry.io/welcome/"
      }}>{`Sentry`}</a>{` slack channel started blowing up with `}<inlineCode parentName="p">{`ActiveRecord::ConnectioTimeoutError:> could not obtain a database connection within 5.000 seconds`}</inlineCode>{` errors.`}</p>
    <p>{`That's a bad error because it means your server couldn't establish a connection to your database. When that happens, nothing works. The request fails and the user cries.`}</p>
    <p>{`Luckily most errors happened in background processes and users didn't notice. Think we got 1 actual user complaint?`}</p>
    <p><img parentName="p" {...{
        "src": "/0584d2460896feb61d19d52bda3903bc/media-EDt1m8p5hqXG8-giphy.gif",
        "alt": "phew giphy"
      }}></img></p>
    <p>{`But a 3% error rate `}<em parentName="p">{`every time you do anything`}</em>{` is no joke.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "890px",
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/518cc2aca6addc0122bcdc15ade02d04/7e21b/1iOQWdy.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "52.017937219730946%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'208\\'%20viewBox=\\'0%200%20400%20208\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M365%2061v27l-1-22c0-20%200-21-2-21s-2%201-2%2021l-1%2013-1-8c-2%200-2%202-2%208-1%206-1%205-1-5%200-12%200-13-2-13s-2%201-2%2013c0%209-1%2011-1%206%200-6%200-8-2-7l-1%207v8l-1-7c0-5%200-6-2-6s-2%201-2%206v6l-3-1-7%201%2020%201%2023%201h1c2-1%201-13-1-13l-1%206-1-11c0-15%200-16-2-16s-2%201-2%2016c0%2012-1%209-1-10l-1-27c-2%200-2%204-2%2027m-67%2017c0%205%200%208-1%207l-2-2-2%202-1%203v-3c0-2-3-3-3%200%200%201-1%202-4%201l-7%201%2019%201c12%200%2022%200%2021-1l-4-1h-3c-1%201-1%200-1-3l-1-4c-2%200-2%201-2%204v5l-1-4c-1-5-4-5-4%200l-1-6-1-10c-2%200-2%202-2%2010M38%2079c0%205%200%208-1%207h-3l-3%201c-2%200-3-1-3-2l-1-1-2%202h-1c-2-1-4-1-4%201l16%201%2011-1h-5v-9c0-7%200-8-2-8s-2%201-2%209m215%200v9l-1-7c0-6-1-7-2-7s-2%201-2%207l-1%205c0-2-3-3-3-1%200%201-1%202-3%202-1%201%204%201%2012%201l15%201h1c1-2%200-2-2-2s-2%200-2-5c0-9-3-8-3%200-1%205-1%205-1-2%200-6%200-7-2-7s-2%201-2%207l-1%208v-9l-1-9c-2%200-2%202-2%209M92%20164v28l-1-24c0-20-1-23-2-23s-2%203-2%2023l-1%2024v-21l-1-21c-2%200-2%203-2%2021v21l-1-20c0-19%200-20-2-20s-2%201-2%2020%200%2019-1%204c0-12%200-15-2-15l-1%2015c0%2011-1%2013-1%206%200-8%200-9-2-9l-2-1-2-1c-2%200-2%201-2%2010l-1%2011v-12c0-10%200-11-2-11l-2-1-3-1-1%2012-1%2013v-16c0-14%200-15-2-15s-2-1-2-7c0-5-1-7-2-7-2%200-2%202-2%2022l-1%2023v-23l-1-23c-1%200-2%201-2%203-1%202-1%202-1-1s0-4-2-4-2%201-2%2024v24l-1-21c0-21%200-21-2-21h-2l-2-1c-2%200-2%201-2%2021v22l-1-19c0-16%200-19-2-19l-1%2019c0%2014-1%2015-1%207%200-11%200-12-2-12s-2%201-2%2012v12h16l17%201h1a262%20262%200%200154%200%20265%20265%200%200154%200%20258%20258%200%200153%200%20262%20262%200%200154%200%20254%20254%200%200154%200%20259%20259%200%200153%200l10-1h9v-10l-1-10c-2%200-2%202-2%2010l-1%2010v-10c0-9%200-10-2-10s-2%201-2%2010v10l-1-10c0-7%200-9-2-9l-1%209v10l-1-11c0-9-1-11-2-11s-2%202-2%2011l-1%2011v-13l-1-12c-2%200-2%202-2%2012l-1%2013v-16c0-14%200-15-2-15s-2%201-2%2015l-1%2016v-19l-1-18c-2%200-2%203-2%2018l-1%2019v-19c0-17%200-18-2-18s-2%201-2%2018%200%2017-1%205l-1-13c-2%200-2%203-2%2013l-1%2014v-14c0-12%200-13-2-13s-2%201-2%2013v14l-1-11c0-9%200-11-2-11l-1%2011c0%2010%200%2010-1%202%200-7%200-8-2-8s-2%201-2%208v9l-1-7c0-5%200-7-2-7l-1%207c0%206%200%206-1%201%200-4%200-5-2-5s-2%201-2%205l-1%206v-6l-1-5c-1%200-2%202-2%205l-1%206v-6c0-4%200-5-2-5s-2%201-2%205c-1%204-1%204-1-1l-1-7c-2%200-2%201-2%207l-1%207v-8c0-8%200-8-2-8l-4%201c-2%200-2%201-2%207-1%207-1%206-1-3v-10h-8v10l-1%2011v-12l-1-12c-2%200-2%200-2%2013%200%209%200%209-1%202%200-7%200-8-2-8s-2%201-2%208v9l-1-7c0-5%200-7-2-7l-1%207v7l-1-6c0-5%200-6-2-6s-2%201-2%206v6l-1-6-1-5c-1%200-2%202-2%205l-1%206v-6c0-4%200-5-2-5s-2%201-2%205l-1%206v-7l-1-6c-2%200-2%202-2%206-1%206-1%206-1-2%200-7%200-8-2-8-1%200-2%202-2%209-1%207-1%207-1-4l-1-11c-2%200-2%202-2%2011l-1%2012v-14c0-13%200-14-2-14s-2%201-2%2014v14l-1-13-1-13c-2%200-2%202-2%2013l-1%2013v-14l-1-13c-2-1-3%200-3%203s0%203-1%201l-2-2-1%2012-1%2013v-14l-1-13h-2l-1%203c-1%203-1%203-1%201l-1-3c-2%200-2%202-2%2013%200%209%200%2010-1%205%200-7%200-8-2-8l-1%208-1%207-1-8-1-9c-2%200-2%201-2%209l-1%209v-9c0-9%200-9-2-9h-2l-2-1c-2%200-2%201-2%209-1%209-1%208-1-3l-1-13c-1%200-2%201-2%203-1%201-1-2-1-7%200-8%200-9-2-9s-2%201-2%2019l-1%2020v-25l-1-24c-2%200-2%203-2%2024v25l-1-22c0-20%200-21-2-21s-2%201-2%2021v22l-1-18-1-18c-2%200-2%203-2%2018l-1%2018v-21c0-20%200-21-2-21s-2%201-2%2021v21l-1-19c0-16%200-19-2-19l-1%2019v19l-1-16c0-14%200-15-2-15s-2%201-2%2015c0%209-1%2012-1%207l-1-8c-2%200-2%202-2%208-1%208-1%208-1-2%200-9%200-10-2-10-1%200-2%202-2%2011l-1%2010v-13l-1-13c-2%200-2%202-2%2013l-1%2013v-14l-1-14h-2l-1%2014-1%2014v-17l-1-17c-2%200-2%203-2%2017-1%2015-1%2014-1-7%200-22%200-23-2-23-1%200-2%201-2%204-1%202-1%202-1-2l-1-6c-2%200-2%202-2%2025l-1%2026v-26c0-24%200-25-2-25l-2%202c0%202%200%203-2%202-2%200-2%200-2%2023v24l-1-22c0-18%200-21-2-21l-2%201c0%201-1%202-2%201-2%200-2%201-2%2020v21l-1-20c0-18%200-20-2-20l-1%2010c0%205%200%207-1%204%200-4%200-5-2-5s-2%201-2%2015v16l-1-15-1-14c-2%200-2%203-2%2014l-1%2015v-15c0-13%200-14-2-14s-2%201-2%2014l-1%2015v-15l-1-15c-2%200-2%203-2%2015l-1%2015v-18c0-16%200-17-2-17s-2%201-2%2017c-1%2015-1%2013-1-8l-1-25c-2%200-2%204-2%2025v26l-1-27c0-24-1-27-2-27s-2%203-2%2027l-1%2027v-28l-1-27c-2%200-2%204-2%2027\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/518cc2aca6addc0122bcdc15ade02d04/ca0a1/1iOQWdy.webp 223w", "/static/518cc2aca6addc0122bcdc15ade02d04/75680/1iOQWdy.webp 445w", "/static/518cc2aca6addc0122bcdc15ade02d04/8d1ba/1iOQWdy.webp 890w", "/static/518cc2aca6addc0122bcdc15ade02d04/3838e/1iOQWdy.webp 1335w", "/static/518cc2aca6addc0122bcdc15ade02d04/4dd3a/1iOQWdy.webp 1626w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/518cc2aca6addc0122bcdc15ade02d04/e92b6/1iOQWdy.png 223w", "/static/518cc2aca6addc0122bcdc15ade02d04/e66bf/1iOQWdy.png 445w", "/static/518cc2aca6addc0122bcdc15ade02d04/4ef49/1iOQWdy.png 890w", "/static/518cc2aca6addc0122bcdc15ade02d04/4e814/1iOQWdy.png 1335w", "/static/518cc2aca6addc0122bcdc15ade02d04/7e21b/1iOQWdy.png 1626w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/518cc2aca6addc0122bcdc15ade02d04/4ef49/1iOQWdy.png",
              "alt": "1iOQWdy",
              "title": "1iOQWdy",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`We like to keep `}<inlineCode parentName="p">{`jobs.failure`}</inlineCode>{` at a cool 0.1% or so. Now it shot up to almost 3%. 30 times worse 😬`}</p>
    <p>{`So what happened?`}</p>
    <p>{`We couldn't figure it out for the life of us. The database wasn't out of memory, there were plenty of connections left in the connection pool. Both common causes of connection timeouts.`}</p>
    <p>{`What's worse, our memory and connection usage `}<em parentName="p">{`went down`}</em>{` because of the issue. With 3% less load the database was absolutely thriving. She was loving it!`}</p>
    <p>{`And yet our application was failing.`}</p>
    <p>{`I spent that entire Monday poring through logs, looking at graphs, smashing my face against New Relic graphs, even looked through the entire code diff between now production and old production.`}</p>
    <p>{`Nothing.`}</p>
    <p>{`We didn't change how we talk to the database. We didn't add a bunch of background processes competing for resources. We didn't even change any configuration. One of our queries just happened to start taking 10x longer.`}</p>
    <p><em parentName="p">{`it was a coincidence`}</em></p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "890px",
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/5451e07dc8900f659f584d1adb7cfb24/dca52/ciOFmJZ.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "39.91031390134529%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'160\\'%20viewBox=\\'0%200%20400%20160\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M274%2037l-6%2034-2%207-1-5c-1-7-1-5-3%206%200%209-2%2010-4%203l-2-8c-2-4-3-14-5-29%200-10-2-9-2%202l-1%205-1-5c0-7-2-13-2-7l-3%2031c-1%202-1%203-2%202l-3%202c-1%203-5%204-6%200l-1-2-2%203c-2%204-4%205-6%203-2-1-12%201-12%202s-1%202-3%202c-3%202-7%201-9-2h-1c-1%202-4%201-6-1h-3c-2%202-7%202-8%200l-2-1-2-4-3-5-2-3c0-3-2%200-2%205-1%207-2%208-3%207l-3%201c-2%203-7%203-8%202-1-2-2-2-3-1l-4%201-5%201c-2%201-9-1-9-3s-4-3-7-2l-10%205-5-2c-4-2-4-2-6%200-3%201-3%201-5-1l-2-3h-1c-3%203-6%205-8%204s-3-1-5%202l-3%203-4-3-4-5c0-3-2-2-3%200%200%202-1%202-1%201h-3c-1%201-1%200-2-2-1-6-2-6-3%200l-2%206h-2c-2%201-13%200-14-1h-3c-1%200-2%200-3-2l-3-3-2-2c-1-1-1%206-1%2023v25H22l-11%201%20192%201h192v-25c0-25-1-39-2-39l-2%209-2%209-1-4c-2-4-3-4-3%200%200%203-2%204-2%200%200-5-2-7-3-3%200%205-2%203-2-2s-2-3-3%202v6l-1-5-3-6-1-3-1-6-1-5-2%204-1%205v-8c-1-8-3-8-3%201l-1%209-1%204v-5l-2-12c-2%2023-8%2032-10%2016-1-12-3-13-5-3%200%207-2%208-2%202l-1-2c-1%200-3%208-4%2017l-1%207-1-6-2-16c0-12-2-17-2-8%200%208-2%2010-2%202%200-13-2-23-2-20l-4%2026c0%209%200%2010-2%209l-2-2c-1%201-1%200-2-2-1-5-2-4-3%203-1%208-3%2010-3%203-2-9-2-10-3-7-1%202-1%202-2-3s-2-6-2-4c-3%205-3%206-3%203s-2-3-3%200l-2%2011c-1%209-2%209-2%204l-4-9-3-14c-1-16-3-15-5%200-2%2014-3%2014-3-1l-2-21-1-9-1%2010M51%20147v5h25v-10H51v5m85-4l-1%205v4h45v-9l-22-1-22%201m-125%204v5h34v-9H11v4m71%200v4h47v-8H82v4\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/5451e07dc8900f659f584d1adb7cfb24/ca0a1/ciOFmJZ.webp 223w", "/static/5451e07dc8900f659f584d1adb7cfb24/75680/ciOFmJZ.webp 445w", "/static/5451e07dc8900f659f584d1adb7cfb24/8d1ba/ciOFmJZ.webp 890w", "/static/5451e07dc8900f659f584d1adb7cfb24/3838e/ciOFmJZ.webp 1335w", "/static/5451e07dc8900f659f584d1adb7cfb24/eb054/ciOFmJZ.webp 1550w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/5451e07dc8900f659f584d1adb7cfb24/e92b6/ciOFmJZ.png 223w", "/static/5451e07dc8900f659f584d1adb7cfb24/e66bf/ciOFmJZ.png 445w", "/static/5451e07dc8900f659f584d1adb7cfb24/4ef49/ciOFmJZ.png 890w", "/static/5451e07dc8900f659f584d1adb7cfb24/4e814/ciOFmJZ.png 1335w", "/static/5451e07dc8900f659f584d1adb7cfb24/dca52/ciOFmJZ.png 1550w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/5451e07dc8900f659f584d1adb7cfb24/4ef49/ciOFmJZ.png",
              "alt": "ciOFmJZ",
              "title": "ciOFmJZ",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`Graphs don't just change color like that at the exact same timestamp your deploy went through because of a coincidence.`}</p>
    <p>{`At wit's end we tried a thing.`}</p>
    <p>{`What if we remove that gem we added? That's the only thing left. Could that library that enables CSV data imports have something to do with this?`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "890px",
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/15d4b9a68bd001e48dd6deb6db2d1a83/7f15f/l5RwQu5.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "39.46188340807175%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'157\\'%20viewBox=\\'0%200%20400%20157\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M34%209l1%204h12l12-1v-1c2%200%203-1%201-3H49v1c1%202-2%201-3-1-3-3-4-3-4%200%200%202%200%202-1%201l-2-1-1%201-1%202c-1%201-1%201-1-1l-1-4-1%203m207%2030l-2%208-2%206-2%207v5l-1-6-1-11c0-14-2-4-3%2022-2%2024-4%2038-4%2029%200-3-2-2-4%201-1%204-1%204-3%202h-2c-2%202-2%202-2%200-1-2-1-2-3-1-1%202-1%202-2-1l-2-2v2l-1%203-3-3-4-5-1-2-1%202c0%202%200%202-2-2l-2-3-1%205-1%206v-5c-1-4-3-6-3-2%200%207-7%2011-9%205-2-5-4-5-5-1-1%203-1%203-3%201-1-1-1-1-2%201l-3%205v3l-2-2-2-8c0-5-2-7-2-3%200%205-2%206-2%202%200-12-2-12-5-1l-2%206h-3l-2-1c-1-3-1-2-3%202l-2%204-2-4c-1-3-2-4-3-3s-1%201-2-1c0-4-2-4-3-1%200%202%200%202-2%201-1-2-3-1-4%204l-1%204-2-3-4-3-2-6c-2-5-3-5-6%201l-2%205-1-9-2-9-2%206-5%2010-2%204-2-2c-1-2-1-2-2%202-1%205-2%205-6%201-3-3-5-7-5-13-1-5-3-5-3%200l-1%202-1-2c0-6-2-5-3%202l-1%208-6%202h-9l-11%202-12%201h-4v6l-1%208c0%201%200%202-12%202H6l17%201a686699%20686699%200%2000363%200h9v-10l-1-10-3%202h-18l-2-1h-7l-7-1-4-2-3-2c-2-1-2-1-3%201%200%203-1%203-3%203h-4c-1%202-37%202-38%200l-3-6c-1-4-3-6-5-8l-3-2-2%202c-1%202-2%203-3%202l-1%201c0%202-6%2015-8%2015l-2-2-1-3-2%203c-1%203-3%203-6-1-2-2-2-2-4-1s-2%201-3-3l-3-5-2-5c-2-5-4-5-5%200l-1%205-1-6c-2-5-3-16-5-41l-1-9M37%20146v5h35v-9l-18-1H37v5m95%200v5h45v-9l-23-1h-22v5M6%20147v4h25v-9H6v5m72%200v4h47v-9H78v5\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/15d4b9a68bd001e48dd6deb6db2d1a83/ca0a1/l5RwQu5.webp 223w", "/static/15d4b9a68bd001e48dd6deb6db2d1a83/75680/l5RwQu5.webp 445w", "/static/15d4b9a68bd001e48dd6deb6db2d1a83/8d1ba/l5RwQu5.webp 890w", "/static/15d4b9a68bd001e48dd6deb6db2d1a83/3838e/l5RwQu5.webp 1335w", "/static/15d4b9a68bd001e48dd6deb6db2d1a83/e0a0d/l5RwQu5.webp 1530w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/15d4b9a68bd001e48dd6deb6db2d1a83/e92b6/l5RwQu5.png 223w", "/static/15d4b9a68bd001e48dd6deb6db2d1a83/e66bf/l5RwQu5.png 445w", "/static/15d4b9a68bd001e48dd6deb6db2d1a83/4ef49/l5RwQu5.png 890w", "/static/15d4b9a68bd001e48dd6deb6db2d1a83/4e814/l5RwQu5.png 1335w", "/static/15d4b9a68bd001e48dd6deb6db2d1a83/7f15f/l5RwQu5.png 1530w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/15d4b9a68bd001e48dd6deb6db2d1a83/4ef49/l5RwQu5.png",
              "alt": "l5RwQu5",
              "title": "l5RwQu5",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`It worked. We lost a feature and gained a working system.`}</p>
    <p>{`Digging through the gem's codebase we found this in a dependency.`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=ruby&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=ActiveSupport.on_load(%3Aactive_record)%20do%0A%20%20require%20%22activerecord-import%2Fbase%22%0Aend"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "422px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "52.91479820627802%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'211\\'%20viewBox=\\'0%200%20400%20211\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M32%2047c-3%203-3%20115%200%20118%202%202%203%202%20168%202s166%200%20168-2c3-3%203-115%200-118S35%2044%2032%2047\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/6641c468b813b5272ec8a6ef72bf0af7/ca0a1/techletter.app-screenshot-1571068942366.webp 223w", "/static/6641c468b813b5272ec8a6ef72bf0af7/fc0b3/techletter.app-screenshot-1571068942366.webp 422w"],
                "sizes": "(max-width: 422px) 100vw, 422px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/6641c468b813b5272ec8a6ef72bf0af7/e92b6/techletter.app-screenshot-1571068942366.png 223w", "/static/6641c468b813b5272ec8a6ef72bf0af7/fa5c1/techletter.app-screenshot-1571068942366.png 422w"],
                "sizes": "(max-width: 422px) 100vw, 422px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/6641c468b813b5272ec8a6ef72bf0af7/fa5c1/techletter.app-screenshot-1571068942366.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`and this ...`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=ruby&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=class%20ActiveRecord%3A%3AConnectionAdapters%3A%3APostgreSQLAdapter%0A%20%20include%20ActiveRecord%3A%3AImport%3A%3APostgreSQLAdapter%0Aend"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "558px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "39.91031390134529%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'160\\'%20viewBox=\\'0%200%20400%20160\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M25%2035l-2%201v45l1%2045h353V36l-3-1H25\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/ff90deb80af2c1594a3be2cf1fca7f30/ca0a1/techletter.app-screenshot-1571068942460.webp 223w", "/static/ff90deb80af2c1594a3be2cf1fca7f30/75680/techletter.app-screenshot-1571068942460.webp 445w", "/static/ff90deb80af2c1594a3be2cf1fca7f30/1c397/techletter.app-screenshot-1571068942460.webp 558w"],
                "sizes": "(max-width: 558px) 100vw, 558px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/ff90deb80af2c1594a3be2cf1fca7f30/e92b6/techletter.app-screenshot-1571068942460.png 223w", "/static/ff90deb80af2c1594a3be2cf1fca7f30/e66bf/techletter.app-screenshot-1571068942460.png 445w", "/static/ff90deb80af2c1594a3be2cf1fca7f30/42a8d/techletter.app-screenshot-1571068942460.png 558w"],
                "sizes": "(max-width: 558px) 100vw, 558px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/ff90deb80af2c1594a3be2cf1fca7f30/42a8d/techletter.app-screenshot-1571068942460.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`You know what that means? It means this gem `}<em parentName="p">{`messes with every single Postgres operation in your codebase`}</em>{`.`}</p>
    <p>{`Every single one of them. They go through this gem whether you like it or not.`}</p>
    <p><img parentName="p" {...{
        "src": "/eae4a03796619ba6283ac1beeb55db6c/media-3o7aD3FWKSEaExtk08-giphy-downsized-medium.gif",
        "alt": "fuck_this giphy"
      }}></img></p>
    <p>{`And that's how I lost 2 days of my life that I'm never getting back. A gem monkey patching my database connection.`}</p>
    <p>{`Cheers,`}<br parentName="p"></br>{`
`}{`~Swizec`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      